import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Layout from '@/views/layout'

Vue.use(VueRouter)

const routes = [
  // 开放界面（无需登录直接访问）
  {
    path: '/opened',
    name: 'OPENNED',
    // redirect: '/openned/index',
    component: () => import('@/views/openned/layout'),
    children: [
      {
        path: 'wj/:id',
        name: 'opennedWJ',
        props: true,
        component: () => import('@/views/online/wj-home-page'),
      },
      // 报告
      {
        path: 'report',
        name: 'opennedReport',
        props: true,
        component: () => import('@/views/report/openReportView.vue'),
      }
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: ()=> import('@/views/test'),
  },
  // 登录
  {
    path: '/',
    name: '',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: ()=> import('@/views/login/index'),
  },
  // 个人中心
  {
    path: '/',
    component: Layout,
    redirect: '/accountInfo',
    alwaysShow: true,
    children: [
      {
        path: 'accountInfo',
        name: 'AccountInfo',
        component: () => import('@/views/accountInfo/index'),
        meta: { title: '个人中心', icon: 'el-icon-user', affix: true }
      }
    ]
  },
  // 首页
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    children:[
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', icon: 'el-icon-home'}
      },
      {
        path: '/overview',
        name: 'Overview',
        component: () => import('@/views/overview/index'),
        meta: { title: '数据概览', icon: 'el-icon-data-analysis'}
      }
    ]
  },
  // 系统管理
  {
    path:'/system',
    name:'system',
    redirect: '/system/role',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '系统管理',
      icon: 'el-icon-xitongguanli8',
    },
    children: [
      {
        path: '/system/menu',
        name: 'menu',
        component: () => import('@/views/system/menu'),
        meta: { title: '菜单管理', icon: 'el-icon-caidan'}
      },
      {
        path: '/system/role',
        name: 'role',
        component: () => import('@/views/system/role'),
        meta: { title: '角色管理', icon: 'el-icon-role'}
      },
      {
        path: '/system/dict',
        name: 'dict',
        component: () => import('@/views/system/dict'),
        meta: { title: '系统字典', icon: 'el-icon-System_dictionary'}
      },
      {
        path: '/system/log',
        name: 'log',
        component: () => import('@/views/system/log'),
        meta: { title: '访问日志', icon: 'el-icon-DCSrizhi'}
      }
    ]
  },
  // 基础数据管理
  {
    path:'/basic',
    name:'basic',
    redirect: '/basic/user',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '基础数据',
      icon: 'el-icon-document_settings',
    },
    children: [
      {
        path: '/basic/user',
        name: 'userRole',
        component: () => import('@/views/basic/user'),
        meta: { title: '用户管理', icon: 'el-icon-user'}
      },
      {
        path: '/basic/areaAdmin',
        name: 'areaAdmin',
        component: () => import('@/views/basic/areaAdmin'),
        meta: { title: '区域管理员', icon: 'el-icon-user'}
      },
      {
        path: '/basic/areaJyAdmin',
        name: 'areaJyAdmin',
        component: () => import('@/views/basic/areaJyAdmin'),
        meta: { title: '区域教研员管理', icon: 'el-icon-user'}
      },
      {
        path: '/basic/schoolAdmin',
        name: 'schoolAdmin',
        component: () => import('@/views/basic/schoolAdmin'),
        meta: { title: '学校管理员', icon: 'el-icon-user'}
      },
      {
        path: '/basic/gradeAdmin',
        name: 'gradeAdmin',
        component: () => import('@/views/basic/gradeAdmin'),
        meta: { title: '年级组长', icon: 'el-icon-user'}
      },
      {
        path: '/basic/subjectAdmin',
        name: 'subjectAdmin',
        component: () => import('@/views/basic/subjectAdmin'),
        meta: { title: '学科组长', icon: 'el-icon-user'}
      },
      {
        path: '/basic/teacher',
        name: 'teacherRole',
        component: () => import('@/views/basic/teacher'),
        meta: { title: '教师', icon: 'el-icon-user'}
      },
      {
        path: '/basic/classTeacher',
        name: 'classTeacherRole',
        component: () => import('@/views/basic/classTeacher'),
        meta: { title: '班主任', icon: 'el-icon-user'}
      },
      {
        path: '/basic/student',
        name: 'studentRole',
        component: () => import('@/views/basic/student'),
        meta: { title: '学生', icon: 'el-icon-user'}
      },
      {
        path: '/basic/patriarch',
        name: 'patriarchRole',
        component: () => import('@/views/basic/patriarch'),
        meta: { title: '家长', icon: 'el-icon-user'}
      },
      {
        path: '/basic/school',
        name: 'school',
        component: () => import('@/views/basic/schools'),
        meta: { title: '学校管理', icon: 'el-icon-school'}
      },
      {
        path: '/basic/class',
        name: 'class',
        component: () => import('@/views/basic/class'),
        meta: { title: '班级管理', icon: 'el-icon-banjiguanli'}
      },
      {
        path: '/basic/studentGroup',
        name: 'school',
        component: () => import('@/views/basic/studentGroup'),
        meta: { title: '学生小组管理', icon: 'el-icon-fighter'}
      },
    ]
  },
  // 学业测评
  {
    path:'/xueye',
    name:'xueye',
    redirect: '/xueye/entries',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '学业测评',
      icon: 'el-icon-xueyeceping',
    },
    children: [
      // {
      //   path: '/xueye/dimension',
      //   name: 'xueyeDimension',
      //   component: () => import('@/views/xueye/dimension'),
      //   meta: { title: '维度管理', icon: 'el-icon-weiduguanli'}
      // },
      {
        path: '/xueye/subject',
        name: 'xueyeSubject',
        component: () => import('@/views/xueye/subject'),
        meta: { title: '维度学科管理', icon: 'el-icon-contactsstudent'}
      },
      {
        path: '/xueye/dimension/subject',
        name: 'xueyeSubjectDim',
        component: () => import('@/views/xueye/subjectDim'),
        meta: { title: '学科关键能力', icon: 'el-icon-weiduguanli'}
      },
      {
        path: '/xueye/dimension/thought',
        name: 'xueyeThoughtDim',
        component: () => import('@/views/xueye/thoughtDim'),
        meta: { title: '审辩式思维', icon: 'el-icon-weiduguanli'}
      },
      {
        path: '/xueye/papers',
        name: 'xueyePapers',
        component: () => import('@/views/xueye/papers'),
        meta: { title: '试卷管理', icon: 'el-icon-shijuanguanli'}
      },
      {
        path: '/xueye/project',
        name: 'xueyeProject',
        component: () => import('@/views/xueye/project'),
        meta: { title: '项目管理', icon: 'el-icon-xiangmuguanli'}
      },
      {
        path: '/xueye/pubCount',
        name: 'xueyePubCount',
        component: () => import('@/views/xueye/pubCount'),
        meta: { title: '项目统计', icon: 'el-icon-s-data'}
      },
    ]
  },
  // 在线测评
  {
    path:'/online',
    name:'online',
    redirect: '/online/questionnaire',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '在线测评',
      icon: 'el-icon-zaixianceping',
    },
    children: [
      {
        path: 'dimension',
        name: 'onlineDimension',
        component: () => import('@/views/online/dimension'),
        meta: { title: '维度管理', icon: 'el-icon-weiduguanli'}
      },
      {
        path: 'question',
        name: 'onlineQuestion',
        component: () => import('@/views/online/question'),
        meta: { title: '题库管理', icon: 'el-icon-tikuguanli'}
      },
      {
        path: 'questionnaire',
        name: 'onlineQuestionnaire',
        component: () => import('@/views/online/questionnaire'),
        meta: { title: '测评问卷', icon: 'el-icon-cepingwenjuan'}
      },
      {
        path: 'wj',
        name: 'QuestionView',
        component: () => import('@/views/online/wj-page'),
        meta: { title: '问卷管理', icon: 'el-icon-wenjuanguanli', activeMenu:'/online/question'}
      },
    ]
  },
  // 报告管理
  {
    path:'/report',
    name:'report',
    redirect: '/report/studentReport',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '报告管理',
      icon: 'el-icon-baogaoguanli',
    },
    children: [
      {
        path: 'studentForm',
        name: 'studentForm',
        component: () => import('@/views/report/studentForm'),
        meta: { title: '学生报告组建', icon: 'el-icon-xueshengbaogaozujian'}
      },
      {
        path: 'studentReport',
        name: 'studentReport',
        component: () => import('@/views/report/studentReport'),
        meta: { title: '学生报告', icon: 'el-icon-xueshengbaogao'}
      },
      {
        path: 'schoolReport',
        name: 'schoolReport',
        component: () => import('@/views/report/schoolReport'),
        meta: { title: '学校报告', icon: 'el-icon-xuexiaobaogao'}
      },
      {
        path: 'areaReport',
        name: 'areaReport',
        component: () => import('@/views/report/areaReport'),
        meta: { title: '区域报告', icon: 'el-icon-quyubaogao'}
      },
      {
        path: 'reportView',
        name: 'ReportView',
        component: () => import('@/views/report/reportView'),
        // meta: { title: '报告', icon: ''}
      },
    ]
  },
  // 课堂观察
  {
    path:'/classroom',
    name:'classroom',
    redirect: '/classroom/eval',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '课堂观察',
      icon: 'el-icon-ketangguancha',
    },
    children: [
      {
        path: 'dimension',
        name: 'classroomDimension',
        component: () => import('@/views/classroom/dimension'),
        meta: { title: '维度管理', icon: 'el-icon-weiduguanli'}
      },
      {
        path: 'customRules',
        name: 'classroomCustomRules',
        component: () => import('@/views/classroom/customRules'),
        meta: { title: '自定义评价依据', icon: 'el-icon-s-operation'}
      },
      {
        path: 'eval',
        name: 'classroomEval',
        component: () => import('@/views/classroom/eval'),
        meta: { title: '课堂观察点评', icon: 'el-icon-ketangdianping'}
      },
      {
        path: 'evalCount',
        name: 'classroomEvalCount',
        component: () => import('@/views/classroom/evalCount'),
        meta: { title: '点评统计', icon: 'el-icon-s-data'}
      },
      {
        path: 'evalOverview',
        name: 'classroomEvalOverview',
        component: () => import('@/views/classroom/evalOverview'),
        meta: { title: '各校点评概览', icon: 'el-icon-office-building'}
      },
    ]
  },
  // 积分商城
  {
    path: '/shop',
    name:'shop',
    redirect: '/shop/index',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '积分商城',
      icon: 'el-icon-s-shop',
    },
    children:[
      {
        path: '/shop/index',
        name: 'shopIndex',
        component: () => import('@/views/shop/index'),
        meta: { title: '商品管理', icon: 'el-icon-sell'}
      },
      {
        path: '/shop/type',
        name: 'shopType',
        component: () => import('@/views/shop/type'),
        meta: { title: '商品类型', icon: 'el-icon-s-finance'}
      },
      {
        path: '/shop/goods',
        name: 'shopGoods',
        component: () => import('@/views/shop/goods'),
        meta: { title: '商品兑换', icon: 'el-icon-goods'}
      },
      {
        path: '/shop/order',
        name: 'shopOrder',
        component: () => import('@/views/shop/order'),
        meta: { title: '商品订单', icon: 'el-icon-tickets'}
      },
    ]
  },
  // 新闻中心
  {
    path: '/',
    redirect: '/news',
    component: Layout,
    children:[
      {
        path: '/news',
        name: 'News',
        component: () => import('@/views/news/index'),
        meta: { title: '新闻中心', icon: 'el-icon-ziyuan'}
      }
    ]
  },
]

const router = new VueRouter({
  mode: "history",
  routes
})

// 全局错误处理：捕获 Vue Router 3.x 的重复导航错误
router.onError((error) => {
  // 忽略重复导航错误，这是 Vue Router 3.x 的正常行为
  if (error.name === 'NavigationDuplicated') {
    return;
  }
  // 其他错误可以在这里处理
  console.error('路由错误:', error);
});

router.beforeEach((to, from, next) => {
  // console.error(to, from, '=== created == beforeEach ===');
  const matcheds = to.matched||[];
  const {name} = matcheds[0]||{};
  const otherRouterNames = [
    'QuestionView',
    'AccountInfo',
    'ReportView',
    'Test'
  ];
  if(otherRouterNames.includes(to.name)){
    to.meta.activeMenu = from.meta.activeMenu||from.path||to.meta.activeMenu;
  }
  if (to.name != 'login' && !localStorage.getItem("token") && name!='OPENNED') {
    // 如果已经在登录页，避免重复导航
    if (from.name !== 'login') {
    next({
      name: 'login'
      });
    } else {
      next(false); // 取消导航
    }
  } else {
    const { menu } = store.state;
    const { width=0, mini=true } = Vue.prototype.$config;
    if(!mini){
      sessionStorage.setItem('collapse', true);
      store.dispatch('setSideBar', true);
    }
    if (!otherRouterNames.includes(to.name) && to.name != 'login' && menu && !hasValue(menu, to.path) && name!='OPENNED') {
      // 如果目标路由已经是 /home，避免重复导航
      if (to.path !== '/home' && from.path !== '/home') {
        next('/home');
      } else {
        next();
      }
      // Message.error({
      //   message:"暂无权限访问！",
      // });
      return;
    }
    next();
  }
})

const hasValue = (arr=[], target='') =>{
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (item.uri === target) {
      return true;
    } else if (Array.isArray(item.childs)) {
      if (hasValue(item.childs, target)) {
        return true;
      }
    }
  }
  return false;
}

export default router
